import { theme, Typography, Flex, Card } from 'antd'
import useMobileView from '@shared/hooks/isMobile'
import { StarOutlined } from '@ant-design/icons'

const { Title, Text } = Typography
export const Statistics = () => {
    const isMobile = useMobileView()

    const {
        token: { colorPrimary, colorHighlight }
    } = theme.useToken()

    const items = [
        {
            icon: <StarOutlined style={{ fontSize: 15, color: colorPrimary }} />,
            value: '12 000',
            title: 'Подписчики'
        },
        {
            icon: <StarOutlined style={{ fontSize: 15, color: colorPrimary }} />,
            value: '12 000',
            title: 'Просмотры'
        },
        {
            icon: <StarOutlined style={{ fontSize: 15, color: colorPrimary }} />,
            value: '12 000',
            title: 'Прирост 30д'
        },
        {
            icon: null,
            value: '12 000',
            title: 'Ср.охват поста'
        },
        {
            icon: null,
            value: '12 000',
            title: 'Ср.охват 48ч'
        },
        {
            icon: null,
            value: '12 000',
            title: 'Ср.охват 24ч'
        },
        {
            icon: null,
            value: '12%',
            title: 'ERR'
        },
        {
            icon: null,
            value: '12',
            title: 'Подписчики'
        },
        {
            icon: null,
            value: '1245',
            title: 'Подписчики'
        }
    ]
    if (isMobile) {
        return (
            <Card style={{ backgroundColor: '#fff' }} bodyStyle={{ padding: '15px' }}>
                <Card
                    style={{ backgroundColor: '#F0F3F5', fontSize: 16, fontWeight: 500, marginBottom: '10px' }}
                    bodyStyle={{ padding: '4px' }}
                >
                    <Flex justify={'center'}>
                        <Text style={{ fontSize: 16, fontWeight: 500, color: '#7C9BAD', textAlign: 'center' }}>
                            Описание
                        </Text>
                    </Flex>
                </Card>
                <Text style={{ color: '#7C9BAD' }}>
                    Описание взято из описания канала и имеет ограниченное число символов
                </Text>

                <Card
                    style={{ backgroundColor: '#F0F3F5', fontSize: 16, fontWeight: 500, marginTop: 10 }}
                    bodyStyle={{ padding: '4px' }}
                >
                    <Flex justify={'center'}>
                        <Text style={{ fontSize: 16, fontWeight: 500, color: '#7C9BAD', textAlign: 'center' }}>
                            Глубокая аналитика
                        </Text>
                    </Flex>
                </Card>

                <Flex gap={8} justify={'space-between'} style={{ marginBottom: 25, marginTop: 25 }}>
                    {items.slice(0, 3).map((item) => (
                        <Flex
                            key={item.title}
                            style={{
                                backgroundColor: colorHighlight,
                                borderRadius: '8px',
                                width: '100%',
                                position: 'relative'
                            }}
                            vertical
                            align="center"
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    top: -10,
                                    border: '1px solid #7C9BAD',
                                    backgroundColor: 'white',
                                    borderRadius: 5,
                                    padding: 5,
                                    display: 'flex'
                                }}
                            >
                                {item.icon}
                            </div>
                            <Title style={{ marginTop: 20, marginBottom: 0, fontSize: 14 }} level={5}>
                                {item.title}
                            </Title>
                            <Text strong style={{ color: colorPrimary, fontSize: 16, fontWeight: 500 }}>
                                {item.value}
                            </Text>
                        </Flex>
                    ))}
                </Flex>
                <Card style={{ backgroundColor: colorHighlight, borderRadius: 8 }} bodyStyle={{ padding: '15px 9px' }}>
                    <Flex gap={20} justify="space-between">
                        {items.slice(3, 6).map((item) => (
                            <Flex
                                key={item.title}
                                style={{
                                    width: '100%',
                                    position: 'relative'
                                }}
                                vertical
                                align="center"
                            >
                                <Text strong style={{ color: colorPrimary, fontSize: 20, fontWeight: 500 }}>
                                    {item.value}
                                </Text>
                                <Text style={{ marginBottom: 0, fontSize: 10 }}>{item.title}</Text>
                            </Flex>
                        ))}
                    </Flex>
                    <Flex gap={20} style={{ marginTop: 20 }} justify="space-between">
                        {items.slice(6, 9).map((item) => (
                            <Flex
                                key={item.title}
                                style={{
                                    width: '100%',
                                    position: 'relative'
                                }}
                                vertical
                                align="center"
                            >
                                <Text strong style={{ color: colorPrimary, fontSize: 20, fontWeight: 500 }}>
                                    {item.value}
                                </Text>
                                <Text style={{ marginBottom: 0, fontSize: 10 }}>{item.title}</Text>
                            </Flex>
                        ))}
                    </Flex>
                </Card>
            </Card>
        )
    }
    return (
        <>
            <Text style={{ color: colorPrimary }}>
                Описание взято из описания канала и имеет ограниченное число символов
            </Text>
            <div style={{ marginTop: 20 }}>
                <Flex gap={15} wrap={'wrap'}>
                    {Array.from(Array(10)).map((_, i) => (
                        <Card
                            key={i}
                            style={{ backgroundColor: '#DDE8EC', width: 273, height: 108 }}
                            bodyStyle={{ padding: '17px 22px 22px 22px' }}
                        >
                            <Flex vertical align={'center'}>
                                <Text strong>Всего постов</Text>
                                <Text style={{ fontSize: 40, fontWeight: 500 }}>45 223</Text>
                            </Flex>
                        </Card>
                    ))}
                </Flex>
            </div>
        </>
    )
}
